<template>
    <div id="wrapper">
        <div class="row">
            <div class="col">
                <a class="navbar-brand" href="javascript:void(0)"><img src="@/assets/img/CAF_B_BLU.png" style="width:250px"></a>
            </div>
            <div class="col">
                <a class="navbar-brand" href="javascript:void(0)"><img src="@/assets/img/logo_satec.png" style="width:180px;background:#00467f"><!--{{ $route.name }}--></a>
            </div>
        </div>
        <div style="margin-bottom: 100px"></div>
        <div class="row">
            <div class="col-sm"></div>
            <div class="col-sm">
              <form :action="'https://sviluppoallergeni.confcom.it/check/'+token+'?data='+data" method="GET">
                <label for="data"><strong>DATA INVIO PREVENTIVO</strong></label>
                <input class="form-control" type="date" placeholder="Data" name="data" v-model="data">
                <input  class="btn float-center" type="submit" style="margin-top: 10px;background:#00467f"><!--v-on:click="inviaData()"-->
              </form>
            </div>
            <div class="col-sm"></div>
        </div> 
        <div style="margin-bottom: 100px"></div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
  components: {},

  data() {
    return {
     token: '',
     data: null,
     response: [],
      urlRichieste: 'https://sviluppoallergeni.confcom.it/',//'https://apiintranet.confcom.it/'
    };
  },
  methods: {
      inviaData: async function(){
          var response1=await axios.get(
            this.urlRichieste + 'check/' + this.token + '?data=' + this.data,
           // "https://sviluppoallergeni.confcom.it/check/"+this.token+"?data=" + this.data,
          {
            headers: {
              'Content-type': 'application/json'
            }
          }
        )//.then(response => { this.response = response.data})
        this.response = response1.data
        //console.log("this.response")
        //console.log(this.response)
        alert("Data inserita")
        this.$router.push({
            path: '/dashboard'
        })
      }
  },

  mounted() {
    this.token = this.$route.query.token
    console.log("token = "+this.token)
  }
};
</script>
<style>
</style>
